import { api } from './client';

const B = '/api/erm/work';

/** The notification bell, notification settings, and ticket watchers. */
export const workNotifications = {
  list: ({ unreadOnly = false, limit = 30 } = {}) =>
    api.get(`${B}/notifications?unreadOnly=${unreadOnly}&limit=${limit}`),
  unreadCount: () => api.get(`${B}/notifications/unread-count`),
  markRead: (ids) => api.post(`${B}/notifications/read`, { ids }),
  markAllRead: () => api.post(`${B}/notifications/read`, { all: true }),
  prefs: () => api.get(`${B}/notifications/prefs`),
  savePrefs: (body) => api.put(`${B}/notifications/prefs`, body),

  watchers: (itemId) => api.get(`${B}/items/${itemId}/watchers`),
  watch: (itemId) => api.post(`${B}/items/${itemId}/watch`),
  unwatch: (itemId) => api.del(`${B}/items/${itemId}/watch`),
  addWatcher: (itemId, employeeId) => api.post(`${B}/items/${itemId}/watchers`, { employeeId }),
  removeWatcher: (itemId, employeeId) => api.del(`${B}/items/${itemId}/watchers/${employeeId}`),
};
